import { HomePageLayoutBlueprint } from '@backstage/plugin-home-react/alpha';
import { Content, Header, Page } from '@backstage/core-components';
import {
  ClockConfig,
  CustomHomepageGrid,
  HeaderWorldClock,
  LayoutConfiguration,
  WelcomeTitle,
} from '@backstage/plugin-home';
import { Fragment } from 'react';

// Placement lives here, not in app-config: the layout deliberately ignores the
// `defaultConfig` prop that page:home would supply. Each `component` must match
// a widget's `params.name`, or the entry is silently dropped.
const defaultGridConfig: LayoutConfiguration[] = [
  {
    component: 'NewHires',
    x: 0,
    y: 0,
    width: 6,
    height: 7,
  },
  {
    component: 'WorkAnniversaries',
    x: 6,
    y: 0,
    width: 6,
    height: 7,
  },
  {
    component: 'HomePageStarredEntities',
    x: 0,
    y: 7,
    width: 6,
    height: 5,
  },
  {
    component: 'RecentlyVisited',
    x: 6,
    y: 7,
    width: 6,
    height: 5,
  },
];

// Backstage defaults md to 10 columns, which wraps the 6 + 6 rows above on
// laptop-width screens; keep 12 down to sm.
const gridCols = { xl: 12, lg: 12, md: 12, sm: 6, xs: 4, xxs: 2 };

const clockConfigs: ClockConfig[] = [
  { label: 'SFO', timeZone: 'America/Los_Angeles' },
  { label: 'NYC', timeZone: 'America/New_York' },
  { label: 'UTC', timeZone: 'UTC' },
  { label: 'WAW', timeZone: 'Europe/Warsaw' },
];

const timeFormat: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
};

export const homePageLayout = HomePageLayoutBlueprint.make({
  params: {
    loader: async () =>
      function CustomHomePageLayout({ widgets }) {
        return (
          <Page themeId="home">
            <Header
              title={<WelcomeTitle language={['English']} />}
              pageTitleOverride="Home"
            >
              <HeaderWorldClock
                clockConfigs={clockConfigs}
                customTimeFormat={timeFormat}
              />
            </Header>
            <Content>
              {/* Unset, padding defaults to the 10px margin and insets the cards. */}
              <CustomHomepageGrid
                config={defaultGridConfig}
                cols={gridCols}
                containerPadding={[0, 0]}
                containerMargin={[20, 20]}
              >
                {widgets.map((widget, index) => (
                  <Fragment key={widget.name ?? index}>
                    {widget.component}
                  </Fragment>
                ))}
              </CustomHomepageGrid>
            </Content>
          </Page>
        );
      },
  },
});
